import { render, staticRenderFns } from "./GarantiForm.vue?vue&type=template&id=0a48db0e&"
import script from "./GarantiForm.vue?vue&type=script&lang=js&"
export * from "./GarantiForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports